import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useState } from "react";

export const PAGE_SIZE = 25;

export const paginate = (list, page, size = PAGE_SIZE) => {
  const start = (page - 1) * size;
  return (list || []).slice(start, start + size);
};

export function PaginationBar({ page, setPage, total, size = PAGE_SIZE, testid = "pagination" }) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / size));
  const [jump, setJump] = useState("");
  if ((total || 0) <= size) return null;
  const cur = Math.min(page, totalPages);
  const start = (cur - 1) * size + 1;
  const end = Math.min(cur * size, total);
  const go = () => {
    const n = parseInt(jump, 10);
    if (!Number.isNaN(n)) setPage(Math.min(totalPages, Math.max(1, n)));
    setJump("");
  };
  return (
    <div className="mt-3 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-border bg-white px-4 py-2.5" data-testid={testid}>
      <span className="text-xs text-muted-foreground sm:text-sm">
        Showing <b className="text-slate-700">{start}–{end}</b> of <b className="text-slate-700">{total}</b>
      </span>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" disabled={cur <= 1} onClick={() => setPage(cur - 1)} data-testid={`${testid}-prev`}>
          <ChevronLeft className="h-4 w-4" /><span className="hidden sm:inline">Prev</span>
        </Button>
        <span className="text-xs font-medium text-slate-600" data-testid={`${testid}-indicator`}>Page {cur} / {totalPages}</span>
        <Button variant="outline" size="sm" disabled={cur >= totalPages} onClick={() => setPage(cur + 1)} data-testid={`${testid}-next`}>
          <span className="hidden sm:inline">Next</span><ChevronRight className="h-4 w-4" />
        </Button>
        {totalPages > 2 && (
          <div className="flex items-center gap-1 pl-1">
            <Input
              value={jump}
              onChange={(e) => setJump(e.target.value.replace(/[^0-9]/g, ""))}
              onKeyDown={(e) => e.key === "Enter" && go()}
              placeholder="#"
              className="h-8 w-14 text-center text-xs"
              data-testid={`${testid}-jump-input`}
            />
            <Button variant="outline" size="sm" onClick={go} data-testid={`${testid}-jump-go`}>Go</Button>
          </div>
        )}
      </div>
    </div>
  );
}
